import React, { useState, useEffect, useCallback, Suspense } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { db, storageRef } from '../firebase';
import { doc, setDoc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { Container, Card, Button, Modal, Form, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../css/PlayerSection.css';
import YesterdayLeaderboard from './YesterdayLeaderboard';
import '../css/Home.css';

const PlayerSection = ({ onPlayerData }) => {
  const navigate = useNavigate();
  const [isNewPlayer, setIsNewPlayer] = useState(false);
  const [name, setName] = useState('');
  const [avatar, setAvatar] = useState('https://eduplayzone.in/quiz-zone/image/default-profile-male.png');
  const [customAvatar, setCustomAvatar] = useState(null);
  const [quizTitle, setQuizTitle] = useState('');
  const [showCreatePlayerModal, setShowCreatePlayerModal] = useState(false);

  useEffect(() => {
    const storedPlayer = localStorage.getItem('playerData');
    if (storedPlayer) {
      const playerData = JSON.parse(storedPlayer);
      const playerRef = doc(db, 'players', playerData.id);
      getDoc(playerRef).then((docSnap) => {
        if (!docSnap.exists()) {
          localStorage.removeItem('playerData');
          setIsNewPlayer(true);
        } else {
          onPlayerData(playerData);
          setIsNewPlayer(false);
        }
      });
    } else {
      setIsNewPlayer(true);
    }
  }, [onPlayerData]);

  const fetchQuizTitle = useCallback(async () => {
    const today = new Date().toISOString().split('T')[0];
    const q = await getDocs(query(collection(db, 'quizzes'), where('publicationDate', '==', today)));
    if (!q.empty) {
      const quizData = q.docs[0].data();
      setQuizTitle(quizData.quizTitle);
    } else {
      setQuizTitle('New quiz available soon');
    }
  }, []);

  useEffect(() => {
    fetchQuizTitle();
  }, [fetchQuizTitle]);

  const handleStartQuizClick = () => {
    setShowCreatePlayerModal(true);
  };

  const handleCreatePlayer = async (e) => {
    e.preventDefault();
    const playerId = uuidv4();
    const gender = avatar === 'https://eduplayzone.in/quiz-zone/image/default-profile-male.png' ? 'male' : 'female';
    const playerData = { id: playerId, name, avatar, gender };

    try {
      if (customAvatar) {
        const avatarRef = storageRef.child(`avatarsImage/${uuidv4()}_${customAvatar.name}`);
        await avatarRef.put(customAvatar);
        const avatarUrl = await avatarRef.getDownloadURL();
        playerData.avatar = avatarUrl;
      }

      await setDoc(doc(db, 'players', playerId), playerData);
      localStorage.setItem('playerData', JSON.stringify(playerData));
      onPlayerData(playerData);
      setShowCreatePlayerModal(false);
      navigate('/');
    } catch (error) {
      console.error('Error saving player data:', error);
      alert('Error saving player data. Please try again.');
    }
  };

  const handleCustomAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCustomAvatar(file);
      const reader = new FileReader();
      reader.onload = () => {
        setAvatar('custom');
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Container className="player-section-container d-flex justify-content-center align-items-center flex-column ">
      {isNewPlayer ? (
        <>
               {/*Rocket*/}
        {/* <img className='rocket' style={{ height: '80px' }} src='/quiz-zone/image/rocket.png' alt="space day india"/> */}
        {/* Astronaut*/}
        {/* <img className='astronaut' style={{ height: '80px' }} src='/quiz-zone/image/astronaut.png' alt="space day india"/> */}
        {/* satelite*/}
        {/* <img className='satelite' style={{ height: '80px' }} src='/quiz-zone/image/satelite.png' alt="space day india"/> */}
               
          <header className="Header-home">
          <div className='home-logo-sec'>
            <div className='left-nav-logo'>
              <img src='https://eduplayzone.in/image/epz-favicon.png' alt="eduplayzone quiz zone" />
              <h4 className='logo-text'>Quiz zone</h4>
            </div>
            <div>
              <button type="button" style={{background: '#ffef9a', color:'#ff9c00', borderColor:'#ff9c00'}} className="btn btn-secondary btn-sm edit-p-b" onClick={handleStartQuizClick}>
              <i className="fa-solid fa-user-plus"></i> Add Profile
              </button>
            </div>
          </div>
          </header>
          <div className='Quiz-text'>
            {/* <h5>Celebrate India's Lunar Triumphs with EduPlayZone's Space Day Quiz! – Earn Your Certificate! </h5> */}
            <h5>Welcome to the Daily Quiz Challenge!</h5>
            {/* <p>Join EduPlayZone's Space Day Quiz to honor ISRO's achievements. Test your knowledge, climb the leaderboard, and journey to the Moon with daily quizzes leading up to August 23rd. Celebrate National Space Day with us!</p> */}
            <p>Join the daily quiz challenge! Test your knowledge, rise up the leaderboard, and win exciting prizes. Stay engaged with fresh, daily quizzes and compete with players from around the world.</p>
          </div>
        <div className="text-center card-quiz-day" style={{ padding: '20px' }}>
          <Card.Body>
            <Card.Title>Daily Quiz <span>5 questions</span></Card.Title>
            <div className="topic-card-m">
              <span>Today's Topic</span>
              <h6 className="Quiz-topic">{quizTitle}</h6>
              <Button variant="primary" onClick={handleStartQuizClick}>
                Start Quiz
              </Button>
            </div>
          </Card.Body>

        </div>
            <section className="winner-board-sec">
              <Suspense fallback={<Spinner animation="border" />}>
                <YesterdayLeaderboard quizDate={new Date().toISOString().split('T')[0]} />
              </Suspense>
            </section>
        </>
      ) : (
        <div className='welcome-back-text'>
            <div >
              <h2>Welcome Back!</h2>
              <div className="loadingtext">
                <p>Loading</p>
              </div>
            </div>
        </div>

      )}

      <Modal show={showCreatePlayerModal} onHide={() => setShowCreatePlayerModal(false)}>
        <Modal.Header >
          <Modal.Title>Create Player</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleCreatePlayer}>
            <Form.Group className="mb-3" controlId="formPlayerName">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                pattern="^[A-Za-z ]+$"  // Regex pattern for name validation
                title="Name should only contain letters and spaces."
                required
              />
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label>Choose Avatar</Form.Label>
              <div className="d-flex justify-content-around">
                <div
                  className={`avatar ${avatar === 'https://eduplayzone.in/quiz-zone/image/default-profile-male.png' ? 'selected' : ''}`}
                  onClick={() => setAvatar('https://eduplayzone.in/quiz-zone/image/default-profile-male.png')}
                >
                  <img
                    src="https://eduplayzone.in/quiz-zone/image/default-profile-male.png"
                    alt="Male Avatar"
                  />
                </div>
                <div
                  className={`avatar ${avatar === 'https://eduplayzone.in/quiz-zone/image/default-profile-female.png' ? 'selected' : ''}`}
                  onClick={() => setAvatar('https://eduplayzone.in/quiz-zone/image/default-profile-female.png')}
                >
                  <img
                    src="https://eduplayzone.in/quiz-zone/image/default-profile-female.png"
                    alt="Female Avatar"
                  />
                </div>
                <div
                  className={`avatar ${avatar === 'custom' ? 'selected' : ''}`}
                  onClick={() => document.getElementById('customAvatarInput').click()}
                >
                  {avatar === 'custom' && customAvatar && (
                    <img
                      src={URL.createObjectURL(customAvatar)}
                      alt="Custom Avatar"
                    />
                  )}
                  {!customAvatar && (
                    <span className="custom-avatar-text"><img className="add-image-btn" src="/quiz-zone/image/add-image.png" alt="Add Avatar" /></span>
                  )}
                </div>
              </div>
              <Form.Control
                type="file"
                id="customAvatarInput"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handleCustomAvatarChange}
              />
            </Form.Group>
            <Button variant="primary" type="submit">
              Start Quiz
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default PlayerSection;
